import { useState, useCallback } from 'react';
import { FormData } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';

const INITIAL_FORM_DATA: FormData = {
  topic: '',
  questionCount: 3,
  sensitiveTopics: '',
  selectedTemplate: '',
  level: 'Intermediate'
};

export const useFormState = () => {
  const [formData, setFormData] = useState<FormData>(INITIAL_FORM_DATA);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const resetForm = useCallback(() => {
    setFormData(INITIAL_FORM_DATA);
  }, []);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return {
    formData,
    setFormData,
    isSubmitting,
    setIsSubmitting,
    showModal,
    resetForm,
    openModal,
    closeModal
  };
};
